import React from 'react';

import NcContadorLiderancaInspiradora from './components/NcContadorLirerancaInspiradora/NcContadorLirerancaInspiradora';

const ListaAcademia = () => {
    return ( 
        <>
            {/* <h2>Lista de peças para "Academia de Liderança VD"</h2> */}
            <NcContadorLiderancaInspiradora />
        </>
     );
}
 
export default ListaAcademia;